<template>
  <div>
    <!-- 二开页面代码 -->
    <!-- 注:路由请使用PageRouter方式 -->
    <a href="#" style="color: #409EFF;" @click="dataBackfill">超链接数据回填案例</a>
  </div>
</template>
<script>
export default {
  name: 'HyperLinkDialogExample',
  data() {
    return {
      centerDialogVisible: false
    }
  },
  mounted() {
    let params = this.$route.query
    console.log(params)// 获取路由参数
  },
  methods: {
    dataBackfill() {
      let dataJson =
      {
        'columnList':
        [
          {
            'prop': 'processCode',
            'label': '流程编号1', // 修改属性
            'value': 'PROP20200715105038'// 修改字段内容
          }
        ]
      }
      // 数据回填/修改表单属性（格式与联动url方式一致）
      parent.JsDataInteraction(dataJson)
      // 关闭窗口
      parent.closeWindow()
    }
  }
}
</script>
